module.exports = __webpack_public_path__ + "img/avatar-s-18.jpg";